import { toRaw } from 'ui.vue3';
import { Core } from 'booking.core';
import { ResourceModel } from './types';

export function getResource(resourceId: number): ResourceModel
{
	const store = Core.getStore();
	const resource = store.getters['resources/getById'](resourceId);

	return structuredClone(toRaw(resource));
}

export function getEmptyResource(): ResourceModel
{
	return {
		id: null,
		typeId: null,
		name: '',
		description: null,
		avatar: null,
		slotRanges: [],
		counter: null,
		entities: [],
		isMain: true,
		isPrimary: false,
		isDeleted: false,
		isConfirmationNotificationOn: false,
		isFeedbackNotificationOn: false,
		isInfoNotificationOn: false,
		isDelayedNotificationOn: false,
		isReminderNotificationOn: false,
		templateTypeConfirmation: 'animate',
		templateTypeFeedback: 'animate',
		templateTypeInfo: 'animate',
		templateTypeDelayed: 'animate',
		templateTypeReminder: 'base',
		createdBy: 0,
		createdAt: 0,
		updatedAt: null,
		skus: [],
		skusYandex: [],
	};
}
